import TagColor from './TagColor'

// Y N state Color
export const YNColor = {
  Y: TagColor.blue,
  N: TagColor.gray,
  '1': TagColor.blue,
  '2': TagColor.gray,
  enable: TagColor.blue,
  disable: TagColor.gray,
  online: TagColor.blue,
  offline: TagColor.gray,
  在线: TagColor.blue,
  离线: TagColor.gray,
  true: TagColor.blue,
  false: TagColor.gray,
  已修改: TagColor.blue,
  未修改: TagColor.gray,
  开机: TagColor.blue,
  待机: TagColor.gray,
  已消除: TagColor.gray,
  报警中: TagColor.orange
}

// 使用状态 state Color
export const useStatusColor = {
  投放: TagColor.green,
  停用: TagColor.red,
  报废: TagColor.gray
}

// 订单状态 state Color
export const orderStatusColor = {
  auditing: TagColor.green,
  create: TagColor.blue,
  reject: TagColor.red,
  cancel: TagColor.gray
}

// 接单状态 state Color
export const receiveStatusColor = {
  no: TagColor.red,
  part: TagColor.yellow,
  all: TagColor.green
}

// 发货状态 state Color
export const deliverStatusColor = {
  no: TagColor.red,
  part: TagColor.yellow,
  all: TagColor.green
}

// 签收状态 state Color
export const signStatusColor = {
  no: TagColor.red,
  part: TagColor.yellow,
  all: TagColor.green
}

// 签收明细-签收状态 state Color
export const detailSignStatusColor = {
  reject: TagColor.red,
  no: TagColor.yellow,
  sign: TagColor.green
}
